import { createPortal } from "react-dom";

export default function AttachModal({ patient, onClose }) {
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="simple-modal" onClick={(e) => e.stopPropagation()}>
        <div className="simple-modal-header">
          <h3>{patient.patient}</h3>
        </div>
        <div className="simple-modal-footer">
          <button className="close-btn" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}